// extracted by mini-css-extract-plugin
export default {"body":"OwnedNftBottomDrawer_body__VF11g"};